/**
 * Deze klasse verzorgt alle logica rond een normale pagina, die bestaat uit
 * title
 * content
 * eventueel een field
 *
 * @history
 * 12 juni 2023
 * kiezen locaties en leerlingen
 *
 * 21 juli 2022
 * Basis implementatie
 *
 */
import React from "react";
import {LocationsManager} from "../managers/Locations";
import {PupilsManager} from "../managers/Pupils";
import {WorkModeForm} from "../forms/WorkModeForm";
import {StudentModeForm} from "../forms/StudentModeForm";
import {GroupInit} from "./GroupInit";
import {GroupShowNoEdit} from "./GroupShowNoEdit";

export class Page extends React.Component
{
    constructor(props)
    {
        super(props);


        if (this.props.page.has_field)
        {

            window.app.setLastTextInput({
                name: this.props.page.field.name,
                value: window.app.logboek.getField(this.props.page.field.name)

            });

        }

    }

    onChangeTextInput(event)
    {

        window.app.setLastTextInput({
            name: this.props.page.field.name,
            value: event.target.value.toString()
        });
    }

    onChangeThemaInput(event)
    {

        window.app.storeField(
            event.target.name,
            event.target.value.toString()
        );
    }

    render()
    {
        return (
            <div className={"tool__content__page__wrapper"}>
                <h1>{this.props.page.title}</h1>

                <div className={this.props.page.font_size == "pupil" ? "tool__content__page__content_pupil" : "tool__content__page__content_teacher"} dangerouslySetInnerHTML={{__html: this.props.page.content}}></div>

                {this.props.page.has_field &&
                    (
                        <>
                            {this.props.page.field.type == 'text' &&
                                (
                                    <>
                                        <h2>{this.props.page.field.label} {this.props.page.field.required && (<>(verplicht veld) </>)}</h2>
                                        <input type={"text"} className={"tool__content__page__input"} onChange={this.onChangeTextInput.bind(this)} defaultValue={window.app.logboek.getField(this.props.page.field.name)} placeholder={this.props.page.field.placeholder}/>
                                    </>
                                )

                            }

                            {this.props.page.field.type == 'textarea' &&
                                (
                                    <>
                                        <h2>{this.props.page.field.label} {this.props.page.field.required && (<>(verplicht veld) </>)}</h2>
                                        <textarea className={"tool__content__page__textarea"} onChange={this.onChangeTextInput.bind(this)}>{window.app.logboek.getField(this.props.page.field.name)}</textarea>
                                    </>
                                )

                            }

                            {this.props.page.field.type == 'thema' &&
                                (
                                    <>
                                        <h2>Thema (korte naam, verplicht)</h2>
                                        <input type={"text"} className={"tool__content__page__input"} onChange={this.onChangeTextInput.bind(this)} defaultValue={window.app.logboek.getField('title')} placeholder="Thema (korte naam)"/>
                                        <h2>Themabeschrijving</h2>
                                        <textarea className={"tool__content__page__textarea"} onChange={this.onChangeThemaInput.bind(this)} name="thema_beschrijving">{window.app.logboek.getField('thema_beschrijving')}</textarea>
                                        <h2>Wat is de doelgroep?</h2>
                                        <textarea className={"tool__content__page__textarea"} onChange={this.onChangeThemaInput.bind(this)} name="thema_doelgroep">{window.app.logboek.getField('thema_doelgroep')}</textarea>

                                    </>
                                )

                            }
                        </>
                    )}

                {this.props.page.programmers_field == "qrcode" && (
                    <>
                        <img src={"/get_qrcode/?access_id1=" + window.app.logboek.access_id1 + "&access_id2=" + window.app.logboek.access_id2} className="qrcode_image"/><br/>
                        <a href={"/log/" + window.app.logboek.access_id1 + "/" + window.app.logboek.access_id2} target={"_blank"} className={"button"}>Toon</a>

                    </>
                )}

                {this.props.page.programmers_field == "select_locations" && (
                    <LocationsManager session_active={this.props.session_active}/>
                )}


                {this.props.page.programmers_field == "select_pupils" && (
                    <PupilsManager session_active={this.props.session_active}/>
                )}

                {this.props.page.programmers_field == "group_init" && (
                    <GroupInit mode={'init'}/>
                )}
                {this.props.page.programmers_field == "group_active" && (
                    <>
                        <GroupShowNoEdit show_log/>

                        <img src={"/get_qrcode/?access_id1=" + window.app.logboek.access_id1 + "&access_id2=" + window.app.logboek.access_id2} className="qrcode_image"/><br/>
                        <a href={"/log/" + window.app.logboek.access_id1 + "/" + window.app.logboek.access_id2} target={"_blank"} className={"button"}>Naar de logger</a>
                    </>
                )}

                {this.props.page.programmers_field == "group_review" && (
                    <>
                        <GroupShowNoEdit show_log/>
                    </>
                )}

                {this.props.page.programmers_field == "select_work_mode" && (
                    <WorkModeForm/>
                )}

                {this.props.page.programmers_field == "select_student_mode" && (
                    <StudentModeForm/>
                )}


            </div>

        );
    }

}
